import { createFileRoute } from '@tanstack/react-router'

import { Agents } from '@/widgets/agents'

export const Route = createFileRoute('/_app/agents-hub/')({
  component: RouteComponent,
})

export const AgentsRoute = Route

function RouteComponent() {
  return <Agents />
}
